import { BUILD_ARGS } from '../../../BUILD_ARGS';
import { AppType } from '../model/app-type.model';

export const environment = {
  applicationID: 'az-travel',
  defaultTenant: 'az-travel',
  production: true,
  debug: false,
  mockedApi: false,
  baseApiUrl: 'https://www.turystyka.allianz.pl/',
  deployUrl: BUILD_ARGS.deployUrl,
  version: 'GIT_TAG_VERSION',
  env: 'production',
  sso: '',
  app: AppType.Direct,
  globtroterApp: 'app',
  hotjarId: '3544545',
};
